var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#0098FF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.2803 72.4391C66.7361 72.2589 71.0128 67.69 70.8325 62.2342C70.6523 56.7784 66.0834 52.5018 60.6276 52.682C55.1718 52.8622 50.8951 57.4311 51.0754 62.8869C51.2556 68.3427 55.8245 72.6194 61.2803 72.4391Z",
    stroke: "#0098FF",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6352 65.0695L60.9547 62.5605L60.7915 57.6212",
    stroke: "#0098FF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8274 51.1246L86.8934 46.7807C87.8582 45.75 88.3733 44.3798 88.3267 42.9688C88.27 41.2516 87.3869 39.6671 85.9562 38.7156L78.61 33.8257C77.1978 32.8867 75.5272 32.4112 73.8331 32.4671C71.3223 32.5501 68.9913 33.7875 67.5158 35.8207L62.5593 42.6482C60.3901 45.6356 59.1676 49.1949 59.0318 52.865",
    stroke: "#0098FF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8929 46.7808L88.1062 49.3812C88.4131 50.0386 88.5833 50.7499 88.6072 51.4743C88.6556 52.9397 88.1027 54.3622 87.0758 55.4098L84.1691 58.377C81.9497 60.6442 78.9409 61.9665 75.7715 62.0712L70.3734 65.5576",
    stroke: "#0098FF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1127 63.4643L42.4236 74.4483",
    stroke: "#0098FF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3368 71.8482L54.6399 84.1083",
    stroke: "#0098FF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3898 86.3149L35.0614 72.8243C36.1894 71.3976 38.2615 71.1561 39.6899 72.2841L57.2711 86.1912C58.6978 87.3192 58.9393 89.3913 57.8113 90.8197L55.7434 93.4328",
    stroke: "#0098FF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4318 23.0377C74.3033 22.1262 73.4602 21.4915 72.5488 21.62C71.6373 21.7485 71.0026 22.5915 71.1311 23.503C71.2596 24.4145 72.1027 25.0492 73.0141 24.9207C73.9256 24.7922 74.5603 23.9491 74.4318 23.0377Z",
    fill: "#0098FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2001 13.8283C62.0716 12.9168 61.2286 12.2821 60.3171 12.4106C59.4056 12.5391 58.7709 13.3821 58.8994 14.2936C59.0279 15.2051 59.871 15.8398 60.7824 15.7113C61.6939 15.5828 62.3286 14.7397 62.2001 13.8283Z",
    fill: "#0098FF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2895 15.8121C70.161 14.9007 69.3179 14.266 68.4064 14.3945C67.495 14.523 66.8603 15.366 66.9888 16.2775C67.1173 17.1889 67.9603 17.8237 68.8718 17.6952C69.7833 17.5667 70.418 16.7236 70.2895 15.8121Z",
    fill: "#0098FF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6134 51C20.6134 50.0795 19.8672 49.3333 18.9467 49.3333C18.0262 49.3333 17.28 50.0795 17.28 51C17.28 51.9205 18.0262 52.6666 18.9467 52.6666C19.8672 52.6666 20.6134 51.9205 20.6134 51Z",
    fill: "#0098FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8001 54.0937C26.8001 53.1733 26.0539 52.4271 25.1335 52.4271C24.213 52.4271 23.4668 53.1733 23.4668 54.0937C23.4668 55.0142 24.213 55.7604 25.1335 55.7604C26.0539 55.7604 26.8001 55.0142 26.8001 54.0937Z",
    fill: "#0098FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 60.2799C11.3333 59.3595 10.5871 58.6133 9.66667 58.6133C8.74619 58.6133 8 59.3595 8 60.2799C8 61.2004 8.74619 61.9466 9.66667 61.9466C10.5871 61.9466 11.3333 61.2004 11.3333 60.2799Z",
    fill: "#0098FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8931 60.2799C29.8931 59.3595 29.147 58.6133 28.2265 58.6133C27.306 58.6133 26.5598 59.3595 26.5598 60.2799C26.5598 61.2004 27.306 61.9466 28.2265 61.9466C29.147 61.9466 29.8931 61.2004 29.8931 60.2799Z",
    fill: "#0098FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6134 69.5599C20.6134 68.6394 19.8672 67.8932 18.9467 67.8932C18.0262 67.8932 17.28 68.6394 17.28 69.5599C17.28 70.4803 18.0262 71.2265 18.9467 71.2265C19.8672 71.2265 20.6134 70.4803 20.6134 69.5599Z",
    fill: "#0098FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4264 66.4661C14.4264 65.5456 13.6802 64.7994 12.7597 64.7994C11.8392 64.7994 11.093 65.5456 11.093 66.4661C11.093 67.3866 11.8392 68.1328 12.7597 68.1328C13.6802 68.1328 14.4264 67.3866 14.4264 66.4661Z",
    fill: "#0098FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8001 66.4661C26.8001 65.5456 26.0539 64.7994 25.1335 64.7994C24.213 64.7994 23.4668 65.5456 23.4668 66.4661C23.4668 67.3866 24.213 68.1328 25.1335 68.1328C26.0539 68.1328 26.8001 67.3866 26.8001 66.4661Z",
    fill: "#0098FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4264 54.0937C14.4264 53.1733 13.6802 52.4271 12.7597 52.4271C11.8392 52.4271 11.093 53.1733 11.093 54.0937C11.093 55.0142 11.8392 55.7604 12.7597 55.7604C13.6802 55.7604 14.4264 55.0142 14.4264 54.0937Z",
    fill: "#0098FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7581 20.7717C48.9531 9.82979 37.8082 3.23296 26.8663 6.03791C15.9243 8.84286 9.32749 19.9877 12.1324 30.9297C14.9374 41.8717 26.0823 48.4685 37.0242 45.6635C38.4415 45.3002 39.7822 44.7918 41.0421 44.1662L46.7427 47.1024C47.5959 47.5425 48.5686 46.7681 48.3299 45.8369L46.8031 39.8811C51.4534 34.9475 53.5662 27.8251 51.7581 20.7717Z",
    stroke: "#0098FF",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3299 19.1448H35.6756C35.4183 19.1448 35.2102 18.937 35.2102 18.6799V16.8206C35.2102 16.5635 35.4183 16.3557 35.6756 16.3557H40.3299C40.5873 16.3557 40.7953 16.5635 40.7953 16.8206V18.6799C40.7953 18.937 40.5873 19.1448 40.3299 19.1448Z",
    stroke: "#0098FF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M36.141 19.1469V28.9086C36.141 29.1656 35.933 29.3734 35.6756 29.3734H31.9521",
    stroke: "#0098FF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5176 29.3728L31.923 23.5497C31.8127 23.1458 31.445 22.865 31.0252 22.865H25.4852C25.0212 22.865 24.5916 23.1815 24.5172 23.6385C24.4222 24.2209 24.8699 24.7244 25.4354 24.7244H29.6243",
    stroke: "#0098FF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7945 35.8797C42.8509 35.8797 44.5179 34.2148 44.5179 32.1609C44.5179 30.1071 42.8509 28.4422 40.7945 28.4422C38.7381 28.4422 37.071 30.1071 37.071 32.1609C37.071 34.2148 38.7381 35.8797 40.7945 35.8797Z",
    stroke: "#0098FF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M42.191 32.1596C42.191 32.9298 41.5659 33.5541 40.7947 33.5541C40.0236 33.5541 39.3984 32.9298 39.3984 32.1596C39.3984 31.3894 40.0236 30.7651 40.7947 30.7651",
    stroke: "#0098FF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M30.556 32.1609C30.556 34.2146 28.8888 35.8797 26.8326 35.8797C24.7763 35.8797 23.1091 34.2146 23.1091 32.1609",
    stroke: "#0098FF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2095 18.6802H33.3478C33.0904 18.6802 32.8823 18.4724 32.8823 18.2153V17.2856C32.8823 17.0286 33.0904 16.8208 33.3478 16.8208H35.2095",
    stroke: "#0098FF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7654 19.1469C39.1289 22.2845 44.0522 23.7953 44.0522 27.0492V30.3607",
    stroke: "#0098FF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0725 32.162H28.2492M24.748 24.42C22.9933 24.9188 21.7134 26.5314 21.7134 28.4433V31.6972C21.7134 31.9542 21.9214 32.162 22.1788 32.162H23.0624H23.5564M26.0263 32.162H25.3871",
    stroke: "#0098FF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7134 31.696C21.7134 29.1291 23.7971 27.0475 26.3677 27.0475",
    stroke: "#0098FF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1228 27.2611C38.9164 26.8284 39.8263 26.5825 40.7944 26.5825C42.0091 26.5825 43.135 26.972 44.0528 27.6325",
    stroke: "#0098FF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 16.8868V16.6C21.3333 15.5323 22.1988 14.6667 23.2666 14.6667H28.2917C29.3594 14.6667 30.225 15.5323 30.225 16.6V20.6272C30.225 21.695 29.3594 22.5606 28.2917 22.5606H23.2666C22.1988 22.5606 21.3333 21.695 21.3333 20.6272V20.587",
    stroke: "#0098FF",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7922 14.6664V16.3917C24.7922 17.0737 25.3452 17.6266 26.0272 17.6266V17.6266C26.7093 17.6266 27.2622 17.0737 27.2622 16.3917V14.6664",
    stroke: "#0098FF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.9a6c288630cc9f42317290abe153839c.svg";
export { ForwardRef as ReactComponent };